import { createFileRoute } from "@tanstack/react-router";
import AboutPage from "@/pages/AboutPage";
import { pageHead } from "@/lib/site";

export const Route = createFileRoute("/about")({
  head: () =>
    pageHead(
      "About Scotty's Land Specialist | Highland, Utah Property Services",
      "Meet Scotty's Land Specialist LLC, a locally owned Highland, Utah property-services company owned by Scott Pymm. Land clearing, dumpster rental, cleanup, and snow removal.",
      "/about",
    ),
  component: AboutPage,
});
